import { Link } from 'react-router-dom';
import { Globe, Award, Mic2, ArrowRight } from 'lucide-react';
import './About.css';

const team = [
  { name: 'Dr Jimmy John Thomas', role: 'Vocalist, Keyboard & Guitar, DJ, Anchor', credentials: ['Sangeet Bhaskar', 'Sangeet Visharad', 'MBA', 'International Performer', 'Govt. of Rajasthan Awardee', 'Music Faculty'], img: '/Assets/jimmy-band-jimmy-john-thomas.jpg.jpeg' },
  { name: 'Gaurav Bhatt', role: 'Vocalist & Guitarist', credentials: ['Sangeet Visharad', 'B-High Grade artist, Akashwani (All India Radio) Jaipur', 'Indian Idol Contestant'], img: '/Assets/jimmy-band-gaurav-bhatt.jpg.jpeg' },
  { name: 'Raghvendra Mathur', role: 'Rhythmist — Drums, Octopad', credentials: [], img: '/Assets/jimmy-band-raghvendra-mathur.jpg.jpeg' },
  { name: 'Prakash Gandharv', role: 'Singer, Keyboard, Guitar & Drum Player', credentials: ['Sangeet Visharad', 'Performed with numerous Bollywood artists'], img: '/Assets/mainslide-04.jpg.jpeg' },
  { name: 'Bhavani Shankar Javda', role: 'Rhythmist — Drums, Tabla, Punjabi Dhol, Cajon', credentials: ['Sangeet Visharad', 'Choreographer: Kathak, Jazz, Zumba, Contemporary'], img: '/Assets/jimmy-band-bhavani-shankar-javda.jpg.jpeg' },
];

const genres = ['Bollywood Hits', 'English Retros', 'Sufi Geet', 'Ghazals', 'Indian Classical', 'Folk Fusion'];
const countries = ['USA (2013, 2016 & 2018)', 'UAE (2013, 2017)', 'Russia (2018)', 'France (2019)', 'Germany (2019)', 'Belgium (2019)', 'Switzerland (2019)', 'Nepal (2008, 2012, 2015)'];

export default function About() {
  return (
    <div className="about-page">
      <div className="page-hero">
        <span className="breadcrumb">Home / <span>About Us</span></span>
        <h1>About Jimmy'z Band</h1>
      </div>

      {/* Story */}
      <section className="story-section">
        <div className="container story-inner">
          <div className="story-text">
            <span className="section-tag">Our Story</span>
            <h2 className="section-title">Versatile Live Music Band</h2>
            <div className="red-line" />
            <p>
              A versatile live music band hailing from Pinkcity Jaipur and spreading its melodies across the world with their energetic music that leaves everyone feeling good and wanting for more.
            </p>
            <p>
              We perform Bollywood Hits, English Retros, Sufi, Ghazals, Indian Classical, Folk Fusion and many more. Our passion for music drives us to deliver unforgettable performances at every event, big or small.
            </p>
            <div className="genre-pills">
              {genres.map(g => <span key={g} className="genre-pill">{g}</span>)}
            </div>
            <Link to="/contact" className="btn-primary" style={{ marginTop: 28 }}>
              Book Us <ArrowRight size={16} />
            </Link>
          </div>
          <div className="story-visual">
            <a href="https://www.youtube.com/watch?v=jwjZGmhwgLA" target="_blank" rel="noreferrer" className="story-yt">
              <img src="https://img.youtube.com/vi/jwjZGmhwgLA/hqdefault.jpg" alt="Jimmy'z Band Live" />
              <div className="yt-play-btn">▶</div>
            </a>
            <div className="story-stats">
              <div className="story-stat"><span className="s-num">1500+</span><span className="s-label">Shows</span></div>
              <div className="story-stat"><span className="s-num">4.8★</span><span className="s-label">Rating</span></div>
              <div className="story-stat"><span className="s-num">25+</span><span className="s-label">Years</span></div>
              <div className="story-stat"><span className="s-num">8+</span><span className="s-label">Countries</span></div>
            </div>
          </div>
        </div>
      </section>

      {/* International */}
      <section className="intl-about">
        <div className="intl-about-bg" />
        <div className="container intl-about-inner">
          <div className="intl-header">
            <Globe size={32} style={{ color: 'var(--gold)' }} />
            <div>
              <span className="section-tag" style={{ color: 'var(--gold)' }}>Global Presence</span>
              <h2 className="section-title" style={{ color: 'white' }}>International Appearances</h2>
            </div>
          </div>
          <p style={{ color: 'rgba(255,255,255,0.65)', marginBottom: 32 }}>
            It is exciting and rewarding to take your ensemble to perform and tour abroad! We have performed Indian music in various countries:
          </p>
          <div className="countries-list">
            {countries.map(c => (
              <div key={c} className="country-chip">
                <Globe size={13} /> {c}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="team-about-section">
        <div className="container">
          <div className="section-header-center">
            <span className="section-tag">The Artists</span>
            <h2 className="section-title">Meet The Team</h2>
            <div className="center-line" />
            <p className="section-subtitle" style={{ margin: '16px auto 0', textAlign: 'center' }}>
              Professionals who respect your event and everything it stands for
            </p>
          </div>
          <div className="team-about-grid">
            {team.map((m, i) => (
              <div key={m.name} className="team-about-card card animate-fadeInUp" style={{ animationDelay: `${i * 0.1}s` }}>
                <div className="tab-img">
                  <img src={m.img} alt={m.name} onError={e => { e.target.parentElement.style.background = 'var(--red-pale)'; e.target.style.display = 'none'; }} />
                  <div className="tab-overlay"><Mic2 size={22} /></div>
                </div>
                <div className="tab-info">
                  <h3>{m.name}</h3>
                  <p className="tab-role">{m.role}</p>
                  {m.credentials.length > 0 && (
                    <ul className="tab-creds">
                      {m.credentials.map(c => <li key={c}>{c}</li>)}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Awards CTA */}
      <section className="awards-cta">
        <div className="container">
          <div className="awards-cta-inner">
            <Award size={48} style={{ color: 'var(--gold)' }} />
            <h2>Awarded Best Versatile Band of Jaipur</h2>
            <p>With a magnificent rating of 4.8 out of 5 and recognition from Govt. of Rajasthan, international bodies, and more.</p>
            <Link to="/contact" className="btn-primary">Book Your Event <ArrowRight size={16} /></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
